import React, { useState } from "react";
import Nav from "../../common/Nav";
import Footer from "../../common/Footer";

const MyBookings = () => {
  const [activeTab, setActiveTab] = useState("upcoming");

  // Sample booking data
  const bookingsData = {
    previous: [
      {
        id: 1,
        bookingDate: "2023-09-15",
        hotelName: "Sunset Resort",
        status: "Paid",
        reviewGiven: true,
      },
      {
        id: 2,
        bookingDate: "2023-08-20",
        hotelName: "Mountain View Hotel",
        status: "Canceled",
        reviewGiven: false,
      },
    ],
    current: [
      {
        id: 3,
        bookingDate: "2023-10-05",
        hotelName: "Beachside Villa",
        status: "Paid",
        reviewGiven: false,
      },
    ],
    upcoming: [
      {
        id: 4,
        bookingDate: "2023-11-10",
        hotelName: "Luxury City Hotel",
        status: "Paid",
        reviewGiven: false,
      },
      {
        id: 5,
        bookingDate: "2023-12-25",
        hotelName: "Snowy Peaks Lodge",
        status: "Paid",
        reviewGiven: false,
      },
    ],
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  const handleReviewClick = (bookingId) => {
    alert(`Review and rating for booking ID: ${bookingId}`);
    // Add logic to open a review modal or navigate to a review page
  };

  return (
    <div>
        <div className="p-6">
            <Nav/>
        </div>

   
    <div className="min-h-screen bg-gray-100 mt-12 py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold text-center mb-8">My Bookings</h1>

        {/* Tabs */}
        <div className="flex justify-center space-x-4 mb-8">
          <button
            onClick={() => handleTabChange("upcoming")}
            className={`px-6 py-2 rounded-full ${
              activeTab === "upcoming"
                ? "bg-blue-500 text-white"
                : "bg-white text-gray-700 hover:bg-gray-200"
            } transition duration-300`}
          >
            Upcoming
          </button>
          <button
            onClick={() => handleTabChange("current")}
            className={`px-6 py-2 rounded-full ${
              activeTab === "current"
                ? "bg-blue-500 text-white"
                : "bg-white text-gray-700 hover:bg-gray-200"
            } transition duration-300`}
          >
            Current
          </button>
          <button
            onClick={() => handleTabChange("previous")}
            className={`px-6 py-2 rounded-full ${
              activeTab === "previous"
                ? "bg-blue-500 text-white"
                : "bg-white text-gray-700 hover:bg-gray-200"
            } transition duration-300`}
          >
            Previous
          </button>
        </div>

        {/* Booking List */}
        <div className="space-y-6">
          {bookingsData[activeTab].map((booking) => (
            <div
              key={booking.id}
              className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow duration-300"
            >
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <p className="text-sm text-gray-500">Booking Date</p>
                  <p className="font-medium">{booking.bookingDate}</p>
                </div>
                <div>
                  <p className="text-sm text-gray-500">Hotel Name</p>
                  <p className="font-medium">{booking.hotelName}</p>
                </div>
                <div>
                  <p className="text-sm text-gray-500">Status</p>
                  <p
                    className={`font-medium ${
                      booking.status === "Paid" ? "text-green-500" : "text-red-500"
                    }`}
                  >
                    {booking.status}
                  </p>
                </div>
                <div>
                  {!booking.reviewGiven && booking.status === "Paid" && (
                    <button
                      onClick={() => handleReviewClick(booking.id)}
                      className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 transition duration-300"
                    >
                      Give Review
                    </button>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
    <Footer/>
    </div>
  );
};

export default MyBookings;